import { Trophy, Coins, Share2 } from 'lucide-react';
import { useLang } from '@/contexts/LangContext';

export default function CelebrationModal({ celebration, onShare, onClose }) {
  const { t } = useLang();
  if (!celebration) return null;
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white rounded-3xl w-full max-w-md p-8 text-center gm-pop border-b-4 border-[#E5E5E5]" data-testid="celebration-modal">
        <Trophy size={72} color="#FFC800" strokeWidth={3} fill="#FFC800" className="mx-auto" />
        <h2 className="text-3xl font-extrabold mt-3">{t('completed')}</h2>
        <p className="text-lg font-bold text-[#AFAFAF] mt-1">{t('earned_xp')}</p>
        <p className="text-5xl font-extrabold text-[#1CB0F6] mt-2">+{celebration.xp_gained} XP</p>
        <p className="text-base font-bold text-[#FFC800]">+{celebration.coins_gained} coins</p>
        {celebration.level_up && (
          <p className="mt-4 text-2xl font-extrabold text-[#58CC02]">🎉 {t('level_up')} {celebration.new_level}</p>
        )}
        {Array.isArray(celebration.new_achievements) && celebration.new_achievements.length > 0 && (
          <div className="mt-5 text-left" data-testid="celebration-achievements">
            <p className="text-xs uppercase font-extrabold text-[#FFC800] mb-2">
              Achievement{celebration.new_achievements.length > 1 ? 's' : ''} unlocked
            </p>
            <div className="space-y-2">
              {celebration.new_achievements.map((a) => (
                <div key={a.id} className="flex items-center gap-3 bg-[#FFF7DA] rounded-2xl p-3 border-2 border-[#FFE082]">
                  <Trophy size={26} color={a.color} strokeWidth={3} fill={a.color} />
                  <div className="flex-1 min-w-0">
                    <p className="font-extrabold text-sm truncate">{a.name}</p>
                    <p className="text-xs font-bold text-[#7A7A7A] truncate">{a.desc}</p>
                  </div>
                  <span className="text-xs font-extrabold text-[#FFC800] flex items-center gap-1 whitespace-nowrap">
                    <Coins size={14} strokeWidth={3} fill="#FFC800" /> +{a.coins}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}
        <p className="mt-4 text-sm font-bold text-[#AFAFAF]">{t('next_mission_ready')}</p>
        <div className="grid grid-cols-2 gap-2 mt-6">
          <button onClick={onShare} className="gm-btn gm-btn-secondary py-3" data-testid="celebration-share">
            <Share2 size={18} strokeWidth={2.6} /> Share
          </button>
          <button onClick={onClose} className="gm-btn gm-btn-primary text-lg py-3" data-testid="close-celebration">
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
